import { render } from "./quotedPriceMsg.vue?vue&type=template&id=20bd7ea6"
import script from "./quotedPriceMsg.vue?vue&type=script&lang=js"
export * from "./quotedPriceMsg.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__